module.exports = __webpack_public_path__ + "img/main.0e882e48.jpeg";